import { render, staticRenderFns } from "./SnsOfficialSection.vue?vue&type=template&id=4cdea4a1&scoped=true"
import script from "./SnsOfficialSection.vue?vue&type=script&lang=ts"
export * from "./SnsOfficialSection.vue?vue&type=script&lang=ts"
import style0 from "./SnsOfficialSection.vue?vue&type=style&index=0&id=4cdea4a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdea4a1",
  null
  
)

export default component.exports